import { Command, API_PREFIX, API_VERSION, HttpVerbType } from "../Command";
import { FetchInstallationsScheduleConfigurationRequestData } from "./FetchInstallationsScheduleConfigurationRequestData";
import { FetchInstallationsScheduleConfigurationResponse } from "./FetchInstallationsScheduleConfigurationResponse";

const ENDPOINT = "/schedules";

export class FetchInstallationsScheduleConfigurationCommand extends Command {
  endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
  httpVerb: HttpVerbType = "post";
  payload: FetchInstallationsScheduleConfigurationRequestData;

  constructor(payload: FetchInstallationsScheduleConfigurationRequestData) {
    super();
    this.payload = payload;
  }

  public async execute(): Promise<FetchInstallationsScheduleConfigurationResponse> {
    var res = await this.executeCommand(this.payload);
    return new FetchInstallationsScheduleConfigurationResponse(res);
  }
}
